import React from 'react';
import { Phone } from 'lucide-react';

interface DeliveryFormProps {
  deliveryDate: string;
  email: string;
  whatsapp: string;
  onDeliveryDateChange: (date: string) => void;
  onEmailChange: (email: string) => void;
  onWhatsAppChange: (whatsapp: string) => void;
  deliveryDateError?: boolean;
  emailError?: boolean;
  whatsappError?: boolean;
}

export default function DeliveryForm({
  deliveryDate,
  email,
  whatsapp,
  onDeliveryDateChange,
  onEmailChange,
  onWhatsAppChange,
  deliveryDateError,
  emailError,
  whatsappError,
}: DeliveryFormProps) {
  const getMinDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <div className="bg-white/70 backdrop-blur-sm rounded-2xl shadow-lg p-8 border border-gray-100">
      <h2 className="text-2xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 text-transparent bg-clip-text mb-6">
        Detalhes da Entrega
      </h2>
      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Data de Entrega
          </label>
          <div className="relative">
            <input
              type="date"
              min={getMinDate()}
              value={deliveryDate}
              onChange={(e) => onDeliveryDateChange(e.target.value)}
              className={`w-full px-4 py-2.5 border rounded-xl focus:ring-2 transition-colors appearance-none ${
                deliveryDateError ? 'border-red-500 focus:ring-red-500' : 'border-gray-200 focus:ring-blue-500'
              } bg-white/50 backdrop-blur-sm`}
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Seu Endereço de Email
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
            placeholder="seu@email.com"
            className={`w-full px-4 py-2.5 border rounded-xl focus:ring-2 transition-colors ${
              emailError ? 'border-red-500 focus:ring-red-500' : 'border-gray-200 focus:ring-blue-500'
            } bg-white/50 backdrop-blur-sm`}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Seu WhatsApp
          </label>
          <div className="relative">
            <input
              type="tel"
              value={whatsapp}
              onChange={(e) => onWhatsAppChange(e.target.value)}
              placeholder="(00) 00000-0000"
              className={`w-full px-4 py-2.5 border rounded-xl focus:ring-2 transition-colors pl-4 pr-10 ${
                whatsappError ? 'border-red-500 focus:ring-red-500' : 'border-gray-200 focus:ring-blue-500'
              } bg-white/50 backdrop-blur-sm`}
            />
            <Phone className="absolute right-3 top-3 h-5 w-5 text-gray-400" />
          </div>
        </div>

        <p className="text-sm text-gray-500 mt-4">
          Escolha seu plano de entrega abaixo para completar o envio da sua carta.
        </p>
      </div>
    </div>
  );
}
